import * as React from "react";
import Header from "./Header";
import NavMenu from "./NavMenu";
import MainContent from "../components/MainContent";
import CustomDialogRenderer from "./CustomDialogRenderer";
import Notifications from '../notifications/Notifications'

interface MainLayoutProps {
  userLoggedIn: boolean;
  userRole: string;
  passwordChangeRequired: boolean;
  history: any;
  isLandingPage: boolean;
  isMediaPage: boolean;
}

class MainLayout extends React.Component<MainLayoutProps> {
  public render() {
    const NavBar = this.props.userLoggedIn && !this.props.passwordChangeRequired ? <NavMenu {...this.props} /> : null;
    return (
      <div>
        <div style={{ marginLeft: "auto", marginRight: "auto" }}>
          <div className="row">
            <Header {...this.props} />
          </div>
          {NavBar}
        </div>
        <MainContent isLandingPage={this.props.isLandingPage} isMediaPage={this.props.isMediaPage}>{this.props.children}</MainContent>
        <CustomDialogRenderer />
        <Notifications />
      </div>
    );
  }
}

export default MainLayout;




// WEBPACK FOOTER //
// ./src/common/MainLayout.tsx